import { Component, OnInit } from "@angular/core";

@Component({
  selector: "app-unique-code-view",
  templateUrl: "./unique-code-view.component.html",
  styleUrls: ["./unique-code-view.component.css"],
})
export class UniqueCodeViewComponent implements OnInit {
  title = "Ваш уникальный код";
  code = "0000-0000";

  constructor() {}

  ngOnInit(): void {
    this.code = this.generateUniqueNumber();
  }

  generateUniqueNumber(): string {
    // Получение текущей даты и времени
    const now = new Date();
    const day = String(now.getDate()).padStart(2, "0");
    const month = String(now.getMonth() + 1).padStart(2, "0"); // Месяцы начинаются с 0
    const year = now.getFullYear();
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    // Формирование строки даты и времени
    const dateString = `${day}.${month}.${year} ${hours}:${minutes}:${seconds}`;

    // Генерация хэш-значения
    const hash = this.generateHash(dateString);

    // Преобразование хэш-значения в 8-значное число
    const number = String(hash).padStart(8, "0").slice(0, 8);

    // Вставка тире в середину строки
    const result = number.slice(0, 4) + "-" + number.slice(4);

    return result;
  }

  // Простая хэш-функция для генерации числа из строки
  generateHash(str: string): number {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
      const char = str.charCodeAt(i);
      hash = (hash << 5) - hash + char;
      hash = hash & hash; // Преобразование в 32-битное целое число
    }
    return Math.abs(hash); // Возвращаем положительное число
  }
}
